import { Map as ImmutableMap, List, fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
const baseUrl = 'snippets/v1/render';

// @ts-expect-error ts-migrate FIXME
export const defaultApiWrapper = apiClient => ({
  fetchRenderedContent({
    // @ts-expect-error ts-migrate FIXME
    id,
    // @ts-expect-error ts-migrate FIXME
    contactEmail,
    // @ts-expect-error ts-migrate FIXME
    contactVid,
    // @ts-expect-error ts-migrate FIXME
    objectType,
    // @ts-expect-error ts-migrate FIXME
    subjectId
  }) {
    const supplementalObject = subjectId && subjectId !== 'null' && subjectId !== 'undefined' ? {
      supplementalObjectType: objectType,
      supplementalObjectId: subjectId
    } : {};
    return apiClient.get(baseUrl, {
      query: Object.assign({
        id,
        toEmail: contactEmail,
        vid: contactVid
      }, supplementalObject)
    }).catch(error => {
      Raven.captureException(error);
    });
  },
  // @ts-expect-error ts-migrate FIXME
  fetchUnrenderedContent({
    id
  }) {
    return apiClient.get(`snippets/v1/snippets/${id}`);
  },
  // @ts-expect-error ts-migrate FIXME
  searchSnippets({
    count,
    offset,
    query
  }) {
    return apiClient.post('salescontentsearch/v2/search', {
      data: {
        contentTypesToHydrate: ['SNIPPET'],
        filters: [{
          field: 'content_type',
          values: ['SNIPPET']
        }],
        limit: count,
        offset,
        query
      }
    })
    // @ts-expect-error ts-migrate FIXME
    .then(response => fromJS(response)).catch(error => {
      Raven.captureException(error);
    });
  }
});
export const fetchAllSnippets = () => http.get('snippets/v1/snippets').then(response => ImmutableMap({
  hasMore: false,
  offset: 0,
  // @ts-expect-error ts-migrate FIXME
  count: response.length,
  // @ts-expect-error ts-migrate FIXME
  total: response.length,
  // @ts-expect-error ts-migrate FIXME
  results: List(response).map(snippet => fromJS(snippet))
}));

// @ts-expect-error ts-migrate FIXME
export const searchSnippets = ({
  count,
  offset,
  query
}) => http.post('salescontentsearch/v2/search', {
  data: {
    contentTypesToHydrate: ['SNIPPET'],
    filters: [{
      field: 'content_type',
      values: ['SNIPPET']
    }],
    limit: count,
    offset,
    query
  }
}).then(response => fromJS(response));